import { ImageField, ImageInput } from 'react-admin';
import { Grid } from '@mui/material';
import '../../App.css';

export const EditImages = () => {
  return (
    <Grid container columnSpacing={2} rowSpacing={3}>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_1" label="Image 1: Drawer bottom (96x96)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_2" label="Image 2: MainMenu background (1000x1000)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_3" label="Image 3: Footer Left (or Center Bottom) (height:150, width:0-450)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_4" label="Image 4: Footer Right (or Center Up) (height:150, width:0-450)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>

      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_5" label="Image 5: sponsor page (1248x2778)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_6" label="Image 6: sponsor icon main (50x50)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_7" label="Image 7: sponsor icon drawer (20x20)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>

      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_neur" label="image_neur (1248x2778)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_neur_iconDrawer" label="image_neur_iconDrawer (20x20)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_neur_iconMain" label="image_neur_iconMain (50x50)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_psic" label="image_psic (1248x2778)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>

      <Grid item className="zebra2" xs={12}>
        <ImageInput source="image_psic_iconDrawer" label="image_psic_iconDrawer (20x20)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item className="zebra1" xs={12}>
        <ImageInput source="image_psic_iconMain" label="image_psic_iconMain (50x50)" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
    </Grid>
  );
};
